import { DivProps } from '../../../../typings';
import { MainBlock } from './styles';
import UDFormLabel from 'ud-form/components/label';

type IProps = DivProps & {
  text: string;
};

function Label(props: IProps) {
  const { text, children, ...rest } = props;

  return (
    <MainBlock {...rest}>
      {text && (
        <UDFormLabel style={{ textWrap: 'nowrap' }} className="text-surfaceRomanSilver30">
          {text}
        </UDFormLabel>
      )}
      {children}
    </MainBlock>
  );
}

export default Label;
